import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Twilio Redux States
import { CALL_OUTBOUND_PREAUTH_REQUEST } from "./actionType";
import {
  callOutboundPreauthSuccess,
  callOutboundPreauthFailure,
} from "./action";

// Include helper step with CD (Assuming a helper exist for API calls)
import { postTwilioPreauthAPI } from "../../helpers/fakebackend_helper";

function* callOutboundPreauth() {
  try {
    const response = yield call(postTwilioPreauthAPI);
    yield put(callOutboundPreauthSuccess(response));
  } catch (error) {
    yield put(callOutboundPreauthFailure(error));
  }
}

export function* watchCallOutboundPreauth() {
  yield takeEvery(CALL_OUTBOUND_PREAUTH_REQUEST, callOutboundPreauth);
}

function* twilioSaga() {
  yield all([fork(watchCallOutboundPreauth)]);
}

export default twilioSaga;
